<template>
    <ReactiveModal
        id="task-add-modal"
        modal-size="custom"
        class="modal_plan-task plan-task"
        :class="{'iframe-view': iframeView }"
        title="Добавление проектной задачи"
        @close="close()">
        <template v-if="hideHeaderBtn" v-slot:left-actions>
            <div></div>
        </template>
        <div class="task task_new">
            <div class="task-summary">
                <div class="task-summary__project">
                    <label for="userProjects">Проект:</label>
                    <SelectSearch
                        id="userProjects"
                        name="userProjects"
                        placeholder="Выберите проект"
                        class="task-summary__project-select"
                        :items="userProjects"
                        :active="projectId"
                        :searchText="projectText"
                        @changeSearchText="val => projectText = val.trim()"
                        @selectChange="setProject"
                    />
                </div>

                <div class="task-summary__url">
                    <label for="projectUrl">URL:</label>
                    <input
                        id="projectUrl"
                        v-model.trim="urlText"
                        type="text"
                        class="form-input"
                        placeholder="Введите url"
                        :disabled="!projectId"
                        @blur="checkUrl()"
                    >
                </div>
            </div>
            <p v-if="errorText" class="error-txt">{{ errorText }}</p>
            <div v-if="showNewTaskForm">
                <FormNewTask
                    :urlId="urlId"
                    :service="service"
                    :hide-header-btn="hideHeaderBtn"
                    :allow-no-runs="true"
                    @planTaskCreated="(v) => addTask(v)"
                />
            </div>
            <div v-if="showAddTaskForm">
                <FormAddTask
                    @planTaskCreated="(v) => addTask(v)"
                />
            </div>
        </div>
    </ReactiveModal>
</template>

<script>
import {mapState} from "vuex";
import editableMixin from "@/vue/share/editableMixin";
import FormNewTask from "@/vue/plan/url/Form/FormNewTask";
import FormAddTask from "@/vue/plan/url/Form/FormAddTask";
import SelectSearch from "@common/vue/components/form/SelectSearch";

export default {
    name: "PlanUrlAddTaskModal",
    mixins: [editableMixin],
    components: {
        FormNewTask,
        FormAddTask,
        SelectSearch,
    },
    props: [
        'hideHeaderBtn',
        'iframeView',
    ],
    data() {
        return {
            urlText: '',
            projectText: '',
            initCabinetId: '',
            initProjectId: '',
            projectSelectTouched: false,
            selectedProject: {
              id: null,
              name: '',
              'cabinet_id': null
            },
        };
    },
    computed: {
        ...mapState({
            user: state => state.common.authUser,
            projectId: state => state.common.projectId,
            cabinetId: state => state.common.cabinetId,
            userProjects: state => state.common.userProjects,

            isLoading: state => state.planUrlAdd.isLoading,
            errorText: state => state.planUrlAdd.errorText,
            urlId: state => state.planUrlAdd.addedTask.urlId,
            url: state => state.planUrlAdd.addedTask.url,
            service: state => state.planUrlAdd.addedTask.service,
        }),
        showNewTaskForm() {
            return this.urlId && this.service && this.isLoadingCompleteSuccess;
        },
        showAddTaskForm() {
            return this.url && !this.urlId && !this.service && this.isLoadingCompleteSuccess;
        },
        isLoadingCompleteSuccess() {
          return !this.isLoading && !this.errorText;
        }
    },
    watch: {
        'url': function (val) {
            if (!val) {
                return this.$plan.resetPlanCRUDState();
            }
            if (this.urlId && this.service) {
                this.$plan.openPlanUrlNewTask('', this.urlId, this.service);
            } else {
                this.$plan.openPlanUrlNewTask(0, '', null);
            }
        },
        'projectId': function (id) {
            if (id) {
              this.checkUrl();
            }
        },
    },
    mounted() {
        this.initProjectId = this.projectId;
        this.initCabinetId = this.cabinetId;
    },
    methods: {
        setProject(id) {
            this.projectSelectTouched = true;
            const project = this.userProjects.find((el) => +el.id === +id);
            Object.assign(this.selectedProject, project);

            if (project['cabinet_id'] !== this.cabinetId) {
                this.$store.commit('setCabinetId', project['cabinet_id']);
            }
            this.$nextTick(() => {
                setTimeout(() => {this.$store.commit('setProjectId', id);}, 500);
            });
        },
        checkUrl() {
            this.$store.dispatch('checkExistingURLs', this.urlText);
        },
        close() {
            if (this.projectSelectTouched) {
                if (this.initCabinetId !== this.cabinetId) {
                    this.$store.commit('setCabinetId', this.cabinetId || this.initCabinetId);
                }
                if (this.initProjectId !== this.projectId) {
                    this.$nextTick(() => {
                        this.$store.commit('setProjectId', this.projectId || this.initProjectId);
                    });
                }
            }
            this.$emit('close');
            this.$store.commit('setTaskData', {});
            this.$store.commit('setLoading', true);
            this.$store.commit('setError', '');
            this.$store.commit('setSaveErrors', '');
        },
        addTask(task) {
            if (this.initCabinetId !== this.cabinetId || this.initProjectId !== this.projectId) {
                const { taskId } = task;
                const taskIdUrl = taskId ? `&taskId=${taskId}` : '';
                window.location.href = `/plan-tasks/list/?cabinetId=${this.cabinetId}&projectId=${this.projectId}${taskIdUrl}`;
            } else {
                this.$emit('planTaskCreated', task);
            }
            this.$store.dispatch('fetchPlanProjectStat');
        }
    },
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

#task-add-modal {
  .modal-body {
    min-height: 300px;
  }

  &:not(.iframe-view) .modal-dialog {
    width: 1180px;
  }

  &.iframe-view .modal-dialog {
    width: 100%;
  }
}
.error-txt {
  margin: 0;
  font-size: 80%;
  font-weight: 400;
  color: red;
}
</style>

<style scoped lang="scss">
.task-summary {
    margin: 0 0 50px;
    display: block;
    grid-template-columns: 450px calc(25% - 30px);
    column-gap: 30px;
    &__url {
        margin-top:10px;
    }
    &__project,
    &__url {
        display: block;
        align-items: center;
        gap: 8px;

        label {
            margin: 0 0 5px;
            font-size: 14px;
            font-weight: 600;
            line-height: 21px;
            color: #212529;
        }
    }

    &__project {
        &-select {
            width: 100%;
        }
    }
}
</style>
